/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserMissionItemModel } from './UserMissionItemModel';
import {
    UserMissionItemModelFromJSON,
    UserMissionItemModelFromJSONTyped,
    UserMissionItemModelToJSON,
} from './UserMissionItemModel';

/**
 * 会員登録したユーザのトークンを表します。
 * @export
 * @interface SignupModel
 */
export interface SignupModel {
    /**
     * 会員登録した唯一のIdトークン
     * @type {string}
     * @memberof SignupModel
     */
    idToken: string;
    /**
     * 会員登録した唯一のリフレッシュトークン
     * @type {string}
     * @memberof SignupModel
     */
    refreshToken: string;
    /**
     * 達成したミッション情報
     * @type {Array<UserMissionItemModel>}
     * @memberof SignupModel
     */
    achievedMissionList: Array<UserMissionItemModel>;
}

/**
 * Check if a given object implements the SignupModel interface.
 */
export function instanceOfSignupModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "idToken" in value;
    isInstance = isInstance && "refreshToken" in value;
    isInstance = isInstance && "achievedMissionList" in value;

    return isInstance;
}

export function SignupModelFromJSON(json: any): SignupModel {
    return SignupModelFromJSONTyped(json, false);
}

export function SignupModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idToken': json['idToken'],
        'refreshToken': json['refreshToken'],
        'achievedMissionList': ((json['achievedMissionList'] as Array<any>).map(UserMissionItemModelFromJSON)),
    };
}

export function SignupModelToJSON(value?: SignupModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idToken': value.idToken,
        'refreshToken': value.refreshToken,
        'achievedMissionList': ((value.achievedMissionList as Array<any>).map(UserMissionItemModelToJSON)),
    };
}

